//frontend/src/pages/LogoutPage.tsx
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';

const API_BASE_URL = 'https://api-staging.mitoflux.is';

export default function HomePage() {
  const { user, logout, getAccessTokenSilently } = useAuth0();
  const [result, setResult] = useState('');
  const [token, setToken] = useState<string>('');

  const callApi = async () => {
    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: 'https://api.mitoflux.local',
        },
      });

      const res = await fetch(`${API_BASE_URL}/api/secure`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setResult(await res.text());
    } catch (e: any) {
      setResult(e.message);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>Welcome</h1>
      <p>Logged in as {user?.email}</p>
      <button onClick={callApi}>Call backend</button>
      <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
        Log out
      </button>

      <pre>{result}</pre>
    </div>
  );
}
